<script lang="ts">
	import ProcessingIcon from '$lib/util/ProcessingIcon.svelte';
	import { addDollarSign, getNumBackInUnits, getPrecisionOfMarket } from '$lib/util/util';
	import {
		currentMarket,
		currentPosition,
		maxLeverage,
		loadingPostTradeDetails,
		postTradeDetails
	} from '../../store';
	import { input, leverage, maxInputAmount, validInput } from '../store';
	export let sectionExpanded: boolean = true;
</script>

<div class="flex w-full justify-between">
	<div class="text-fx-grey-400 text-xs">Buying Power Left:</div>
	{#if $maxInputAmount && $input && $validInput}
		<div class="text-fx-grey-300 text-xs font-medium">
			{addDollarSign(
				(
					Number(getNumBackInUnits($maxInputAmount, 18, 2)) -
					Number(getNumBackInUnits($input, 18, 2))
				).toFixed(2)
			)}
		</div>
	{:else}
		<div class="text-fx-grey-300 text-xs font-medium">
			{addDollarSign(Number(getNumBackInUnits($maxInputAmount, 18, 2)))}
		</div>
	{/if}
</div>

<div class="flex-col gap-2 flex" class:hidden={!sectionExpanded}>
	<div class="flex w-full justify-between">
		<div class="text-fx-grey-400 text-xs">Liquidation Price:</div>
		<div class="flex gap-1">
			{#if $loadingPostTradeDetails}
				<ProcessingIcon />
			{/if}
			{#if $postTradeDetails}
				<div class="text-fx-grey-300 text-xs font-medium">
					{addDollarSign(
						getNumBackInUnits(
							$postTradeDetails.liquidationPrice,
							18,
							getPrecisionOfMarket($currentMarket?.asset)
						),
						getPrecisionOfMarket($currentMarket?.asset)
					)}
				</div>
			{:else if $currentPosition}
				<div class="text-fx-grey-300 text-xs font-medium">
					{addDollarSign(getNumBackInUnits($currentPosition.liquidationPrice, 18, 2))}
				</div>
			{:else}
				<div class="text-fx-grey-300 text-xs font-medium">-</div>
			{/if}
		</div>
	</div>

	<div class="flex w-full justify-between">
		<div class="text-fx-grey-400 text-xs">Position Leverage</div>
		<div class="text-fx-grey-300 text-xs font-medium">{$leverage.toFixed(2)}x</div>
	</div>
	<div class="flex w-full justify-between">
		<div class="text-fx-grey-400 text-xs">Max Position Leverage</div>
		<div class="text-fx-grey-300 text-xs font-medium">{$maxLeverage}x</div>
	</div>
</div>
